<form [formGroup]="formG1">

	<triv-input *ngIf="!element.dlId" 
		[fGroup]="formG1" [data]="myInputs.file"
		(fileChosen)="fileChosen($event)"></triv-input>

	<triv-input [fGroup]="formG1" [data]="myInputs.dlBezeichnung"></triv-input>
	<triv-input [fGroup]="formG1" [data]="myInputs.dlBereich"></triv-input>

	<triv-input [fGroup]="formG1" [data]="myInputs.dlGueltigAb"></triv-input>
	<triv-input [fGroup]="formG1" [data]="myInputs.dlGueltigBis"></triv-input>

	<triv-input [fGroup]="formG1" [data]="myInputs.category"></triv-input>

	
	<div style="margin-top: 4em; display: flex; flex-flow: row; justify-content: flex-end">
		<button mat-raised-button 
			*ngIf="!element.dlId"
			(click)="cancel()">Abbrechen</button>
		<span style="width: 2em"></span>
		<button mat-raised-button (click)="reset()">Zurücksetzen</button>
		<span style="width: 2em"></span>
		<button mat-raised-button color="primary" 
			(click)="save()" 
			[disabled]="!formG1.valid">
			Speichern
		</button>
	</div>

</form>
